import React from 'react';

const LoginProblemNotification = () => (
  <div className="hero">
    <h1 className="info">Apologies...</h1>
    <p>
      It is not currently possible to login using Google,
      this should be fixed very soon... message posted <i>6pm Weds 30th</i>.
    </p>
    <p>
      Please email us at <a href="mailto:info@dyzio.co?Subject=login-problems">info@dyzio.co</a>
      if you need urgent assistance.
    </p>
  </div>
);

export default LoginProblemNotification;



/** WEBPACK FOOTER **
 ** ./src/components/login-problem-notification/index.js
 **/